import type { Bank } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { BANKS_KEY } from 'tanstack-hooks/keys';

export function useBanks(enabled: boolean) {
  const banksApi = new BanksApi();

  const { data: banks, isLoading: isLoadingBanks } = useQuery<Bank[]>({
    enabled,
    queryKey: [BANKS_KEY],
    queryFn: () => banksApi.getBanks()
  });

  return { banks: banks ?? [], isLoadingBanks };
}
